<template>
    <div class="modal" id="modal-contact" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header bg-teal text-white font-bold">
<!--                    Book Address-->
                    Company Address Book
                </div>

                <div class="modal-body bg-white">
                    <company-contact-form :masks="this.masks" :symbols="this.symbols" ref="CompanyContactForm" :exchange="this.exchange" @selected="selectContact"></company-contact-form>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-link" type="reset" @click="close()">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'company-contact-modal',
    props:['masks', 'symbols','exchange'],
    data(){
        return {
            forProposal: null,
        }
    },
    mounted() {
        $('#modal-contact').on('hidden.bs.modal', () => {
            this.$refs.CompanyContactForm.clear();
        })

        Bus.$on('openEmailContactModal', data => {
            Bus.$emit('openEmailContactModalParent',data);
        });
    },

    methods: {
        open(forProposal = null) {
            this.$refs.CompanyContactForm.forProposal = forProposal;
            this.$refs.CompanyContactForm.search = '';
            this.$refs.CompanyContactForm.filter = '';
            this.$refs.CompanyContactForm.goToPage(1);
            $(this.$el).modal('show');
        },

        close() {
            $(this.$el).modal('hide');
        },

        selectContact(contact)
        {
            this.$emit('selected', contact);
            $(this.$el).modal('hide');
        },
    }
}
</script>
